export default {
    path: '/admin/brand',
    component: () => import('@/layout/navication/index.vue'),
    children: [
        {
            path: '/',
            component: () => import('@/pages/admin/brand/index.vue')
        }
    ]
};